<!-- Muestra el menú -->
<app-navbar></app-navbar>
<!-- Muestra la barra de progreso -->
<app-progress *ngIf="showProgress"></app-progress>
<!-- Muestra las diferentes páginas del sistema -->
<router-outlet></router-outlet>